export default __webpack_public_path__ + "static/media/poster1.886608bb.svg";